export function MessageSkeleton() {
  return (
    <div className="message-skeleton-list">
      {[1, 2, 3].map((i) => (
        <div key={i} className={`message-skeleton ${i % 2 === 0 ? 'message-skeleton-user' : 'message-skeleton-cade'}`}>
          {i % 2 !== 0 && (
            <div className="message-skeleton-header">
              <div className="skeleton-shimmer skeleton-avatar" />
              <div className="skeleton-shimmer skeleton-name" />
            </div>
          )}
          <div className={`skeleton-shimmer skeleton-body skeleton-body-${i}`} />
        </div>
      ))}
    </div>
  );
}
